import { useState } from "react";
import { toast } from "sonner";
import { useLang } from "@/i18n/LangContext";
import { Mail, MessageSquare, Send } from "lucide-react";

export default function Contact() {
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const submit = (e) => {
    e.preventDefault();
    toast.success(t("contact.sent"));
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <main className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24" data-testid="contact-page">
      <div className="text-xs uppercase tracking-[0.2em] font-bold text-brand-cyan mb-3">
        {t("nav.contact")}
      </div>
      <h1 className="font-heading text-4xl md:text-5xl font-bold mb-3">{t("contact.title")}</h1>
      <p className="text-zinc-400 mb-10">{t("contact.subtitle")}</p>

      <form onSubmit={submit} className="space-y-4 bg-[#0c0c0c] border border-white/5 rounded-xl p-6 md:p-8">
        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-bold mb-2 block">
            {t("contact.name")}
          </label>
          <input
            required
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="w-full bg-[#080808] border border-white/10 rounded-lg px-4 py-3 focus:border-brand outline-none transition-colors"
            data-testid="contact-name"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-bold mb-2 block">
            <Mail className="w-3 h-3 inline me-1" /> {t("contact.email")}
          </label>
          <input
            required
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="w-full bg-[#080808] border border-white/10 rounded-lg px-4 py-3 focus:border-brand outline-none transition-colors"
            data-testid="contact-email"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-bold mb-2 block">
            <MessageSquare className="w-3 h-3 inline me-1" /> {t("contact.message")}
          </label>
          <textarea
            required
            rows={5}
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            className="w-full bg-[#080808] border border-white/10 rounded-lg px-4 py-3 focus:border-brand outline-none transition-colors resize-none"
            data-testid="contact-message"
          />
        </div>
        <button
          type="submit"
          className="bg-brand hover:bg-brand-hover text-white font-semibold px-6 py-3 rounded-lg inline-flex items-center gap-2 glow-blue transition-all"
          data-testid="contact-submit"
        >
          <Send className="w-4 h-4" />
          {t("contact.send")}
        </button>
      </form>
    </main>
  );
}
